import { ActionReducer, Action } from '@ngrx/store';
import { TimeslotReducerInitState } from '../models/timeslot-reducer.interface';

export const UPDATE_TIMESLOT_FORMATTED = 'UPDATE_TIMESLOT_FORMATTED';
export const UPDATE_SELECTED_DATE = 'UPDATE_SELECTED_DATE';
export const UPDATE_SELECTED_GROUP = 'UPDATE_SELECTED_GROUP';
export const UPDATE_SELECTED_TIMESLOT_ID = 'UPDATE_SELECTED_TIMESLOT_ID';
export const UPDATE_SELECTED_TIMESLOT_OVERRIDE_CAPACITY = 'UPDATE_SELECTED_TIMESLOT_OVERRIDE_CAPACITY';
export const UPDATE_SELECTED_TIMESLOT_DATETIME = 'UPDATE_SELECTED_TIMESLOT_DATETIME';
export const UPDATE_SELECTED_POSTCODE = 'UPDATE_SELECTED_POSTCODE';
export const UPDATE_USED_PROMO = 'UPDATE_USED_PROMO';
export const REFRESH_TIMESLOT_STATE = 'REFRESH_TIMESLOT_STATE';
export const RESET_TIMESLOT_STATE = 'RESET_TIMESLOT_STATE';
export const UPDATE_CURRENCY = 'UPDATE_CURRENCY';
export const UPDATE_CUT_OFF_WINDOW = 'UPDATE_CUT_OFF_WINDOW';
export const UPDATE_AMEND_CUT_OFF_WINDOW = 'UPDATE_AMEND_CUT_OFF_WINDOW';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

const initState: TimeslotReducerInitState = {
  timeslotFormattedData: null,
  selectedDate: null,
  selectedGroup: null,
  selectedTimeslotId: null,
  selectedTimeslotOverrideCapacity: null,
  selectedTimeslotDateTime: null,
  selectedPostcode: null,
  usedPromo: false,
  currency: {code: 'GBP', symbol: '£',},
  cutOffTimeWindow : null,
  amendCutOffTimeWindow : null,
};

export function timeslotReducer(state: TimeslotReducerInitState = initState, action: ActionWithPayloadInterface) {

  switch (action.type) {
    case UPDATE_TIMESLOT_FORMATTED:
      return Object.assign({}, state, { timeslotFormattedData: action.payload });

    case UPDATE_SELECTED_DATE:
      return Object.assign({}, state, { selectedDate: action.payload });

    case UPDATE_SELECTED_GROUP:
      return Object.assign({}, state, { selectedGroup: action.payload });

    case UPDATE_SELECTED_TIMESLOT_ID:
      return Object.assign({}, state, { selectedTimeslotId: action.payload });

    case UPDATE_SELECTED_TIMESLOT_OVERRIDE_CAPACITY:
      return Object.assign({}, state, { selectedTimeslotOverrideCapacity: action.payload });

    case UPDATE_SELECTED_TIMESLOT_DATETIME:
      return Object.assign({}, state, { selectedTimeslotDateTime: action.payload });

    case UPDATE_SELECTED_POSTCODE:
      return Object.assign({}, state, { selectedPostcode: action.payload });

    case UPDATE_USED_PROMO:
      return Object.assign({}, state, { usedPromo: action.payload });

    case REFRESH_TIMESLOT_STATE:
      return Object.assign({}, action.payload);

    case RESET_TIMESLOT_STATE:
      return Object.assign({}, initState);

    case UPDATE_CURRENCY:
      return Object.assign({}, state, { currency: action.payload });

    case UPDATE_CUT_OFF_WINDOW:
      return Object.assign({}, state, { cutOffTimeWindow: action.payload });

    case UPDATE_AMEND_CUT_OFF_WINDOW:
      return Object.assign({}, state, { amendCutOffTimeWindow: action.payload });

    default:
      return state;
  }

}
